import DefunctSitesTemplate from './defunct_sites.html.js';

export default class MergedSites extends Backbone.View {
    template = DefunctSitesTemplate;

    constructor({ library, newLibraryName, logoLink, isMergedSite, isTerminatedSite}) {
        super(...arguments);
        this.library = library;
        this.libraryName = library.name;
        this.logo = logoLink;
        this.isMergedSite = isMergedSite;
        this.isTerminatedSite = isTerminatedSite;

        if(isMergedSite){
            this.siteMessage = this._getSiteMessage();
            if(newLibraryName){
                this.mergedLibraryKey = library.mergedLibraryKey
                this.newLibraryName = newLibraryName;
                this.newLibraryUrl = "https://" + this.mergedLibraryKey + ".overdrive.com";
                this._renderMergedSite();
            }else{
                this._renderMergedSite(true);
            }
        }else if(isTerminatedSite){
            this._renderTerminatedSite();
        }
    }

    _getSiteMessage(){
        if(this.library.messages && this.library.messages.length > 0){
            var message = $(`<div>${this.library.messages[0].message}</div>`);
            //if the library message has links in it, do not display the message
            if(message.find('a').length === 0 ){
                return this.library.messages[0].message
            }
        }
        return undefined;
    }

    _renderMergedSite(lessData = false){
        this.$el.empty();
        var options = {
            libraryName: this.libraryName,
            siteMessage: this.siteMessage, 
            logo: this.logo,
            lessData: lessData,
            isMergedSite: this.isMergedSite,
            isTerminatedSite: this.isTerminatedSite
        }
        if(!lessData){
            options.newLibraryName = this.newLibraryName, 
            options.newLibraryURL = this.newLibraryUrl
        }
        
        this.$el.append(this.template(options));
    }

    _renderTerminatedSite(){
        this.$el.empty();
        var options = {
            libraryName: this.libraryName,
            logo: this.logo,
            isMergedSite: this.isMergedSite,
            isTerminatedSite: this.isTerminatedSite
        }
        this.$el.append(this.template(options));
    }
}